<script setup lang="ts">
import { computed, useAttrs } from 'vue'

import DesktopNavigationItem from '@/components/navigation/DesktopNavigationItem.vue'
import {
  NAVIGATION_LOCATIONS,
  useNavigationStore,
} from '@/stores/navigation.store'

defineOptions({ inheritAttrs: false })

const attrs = useAttrs()
const navigationStore = useNavigationStore()
const navigation = computed(() => navigationStore.findByLocation(NAVIGATION_LOCATIONS.primary))
const navAttrs = computed(() => ({
  ...attrs,
  'aria-label': typeof attrs['aria-label'] === 'string'
    ? attrs['aria-label']
    : navigation.value?.name,
}))
</script>

<template>
  <nav
    v-if="navigation?.items.length"
    v-bind="navAttrs"
    :data-navigation-type="navigation.type"
    class="nav primary flex flex-1 items-center justify-end"
  >
    <ul
      class="flex items-center gap-4 text-base font-semibold leading-none"
      :class="navigation.type === 'extended' ? 'lg:gap-8' : 'lg:gap-6'"
    >
      <DesktopNavigationItem
        v-for="item in navigation.items"
        :key="item.id"
        :item="item"
        :navigation-type="navigation.type"
      />
    </ul>
  </nav>
</template>
